<template>
  <ResourceState :new-ui="newUi" :resource="records" :label="label" @reload="load">
    <template #default="{ data }">
      <AppNoResults v-if="!data.results.length" design="new" :title="`No ${label}`" :text="emptyText" />
      <slot v-else :rows="data.results" />
      <AppPagination
        design="new"
        :placement="newUi ? 'embedded' : 'footer'"
        :page="page"
        :pages="data.pages"
        :count="data.count"
        :visible-count="data.results.length"
        :page-size="40"
        @change="changePage"
      />
    </template>
  </ResourceState>
</template>
<script>
import resources, { resource } from './resources'
import ResourceState from './ResourceState.vue'
export default {
  components: { ResourceState },
  mixins: [resources],
  props: {
    newUi: Boolean,
    fetch: Function,
    label: String,
    emptyText: { type: String, default: 'No saved records are available.' }
  },
  data: () => ({ records: resource(), page: 1 }),
  created() {
    this.load()
  },
  methods: {
    async load() {
      const loaded = await this.loadResource(
        this.records,
        () => this.fetch({ page: this.page, page_size: 40 })
      )
      if (loaded && this.records.data) this.$emit('count', Number(this.records.data.count) || 0)
      return loaded
    },
    changePage(page) {
      this.page = page
      this.load()
    }
  }
}
</script>
